var duo_web_sdk = {
  exports: {}
};
export { duo_web_sdk as d };